// @flow

import React from 'react'
import styled from 'styled-components'
import { Input } from 'antd'
import { mediaMin } from 'frontend_core/dist/styles/media'
import Colors from 'components/styles/colors'
import {
  borderRadius,
  spacing,
  fontSize,
} from 'frontend_core/dist/styles/variables'
import LinkText from 'components/atoms/LinkText'
import Icon from 'components/atoms/Icon'
import Button from 'components/atoms/Button'
import Message from 'components/atoms/Message'

const CreateFormBox = styled.div`
  padding: ${spacing.medium}px;
  border: 1px solid ${Colors.grayD};
  border-radius: ${borderRadius}px;
  ${mediaMin.phone`
    padding: ${spacing.medium_2}px;
  `};
`

const CreateFormTitle = styled.h2`
  color: ${Colors.black};
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
  text-align: center;
  ${mediaMin.phone`
    font-size: ${fontSize.medium}px;
  `};
`

const CreateFormDesc = styled.p`
  margin-top: ${spacing.small_2}px;
  color: ${Colors.gray9};
  font-size: ${fontSize.small_2}px;
  text-align: center;
  ${mediaMin.phone`
    font-size: ${fontSize.small}px;
  `};
`

const CreateFormWrapper = styled.div`
  margin-top: ${spacing.medium_2}px;
`

const CreateFormAddText = styled.p`
  display: block;
  margin-bottom: ${spacing.small_2}px;
  font-size: 14px;
  text-align: center;
  ${mediaMin.phone`
    margin-bottom: ${fontSize.medium}px;
  `};
`

const CreateFormButtonContainer = styled.div`
  display: table;
  width: 100%;
  margin-top: ${spacing.medium}px;
  text-align: center;
  ${mediaMin.phone`
    display: block;
  `};
`

const ButtonWrapper = styled.div`
  display: table-cell;
  width: 50%;
  :nth-child(odd) {
    padding-right: ${spacing.small}px;
  }
  :nth-child(even) {
    padding-left: ${spacing.small}px;
  }
  ${mediaMin.phone`
    display: inline-block;
    width: auto;
    }
  `};
`

const MessageWrapper = styled.div`
  margin-top: ${spacing.small_2}px;
`

type PropTypes = {
  errorMessage: string,
  openInputFavoriteName: boolean,
  onClickCreateFavoriteList: Function,
  onChangeFavoriteListName: Function,
  onClickOpenInputFavorite: Function,
  onClickCloseInputFavorite: Function,
  title: string,
  description: string,
  placeholder: string,
  createFormAddText: string,
}

export default (props: PropTypes) => {
  const {
    errorMessage,
    openInputFavoriteName,
    onClickCreateFavoriteList,
    onChangeFavoriteListName,
    onClickOpenInputFavorite,
    onClickCloseInputFavorite,
    title,
    description,
    placeholder,
    createFormAddText,
  } = props

  return (
    <div>
      {openInputFavoriteName ? (
        <form>
          <CreateFormBox>
            <CreateFormTitle>{title}</CreateFormTitle>
            <CreateFormDesc>{description}</CreateFormDesc>
            <CreateFormWrapper>
              <Input
                size="large"
                placeholder={placeholder}
                onChange={onChangeFavoriteListName}
              />
            </CreateFormWrapper>
            {errorMessage && (
              <MessageWrapper>
                <Message errorText={errorMessage} />
              </MessageWrapper>
            )}
            <CreateFormButtonContainer>
              <ButtonWrapper>
                <Button
                  tag="button"
                  buttonType="small"
                  buttonWidthSp={'100%'}
                  buttonWidthPc={150}
                  colorType="gray"
                  onClick={onClickCloseInputFavorite}
                >
                  {i18n.t('page.shared.cancel')}
                </Button>
              </ButtonWrapper>
              <ButtonWrapper>
                <Button
                  tag="button"
                  buttonWidthSp={'100%'}
                  buttonWidthPc={150}
                  buttonType="small"
                  colorType="blue"
                  name="commit"
                  onClick={onClickCreateFavoriteList}
                >
                  {i18n.t('favorite.createList')}
                </Button>
              </ButtonWrapper>
            </CreateFormButtonContainer>
          </CreateFormBox>
        </form>
      ) : (
        <CreateFormAddText>
          <LinkText href="#" onClick={onClickOpenInputFavorite}>
            <Icon positionType="left" className="fa fa-plus" />
            {createFormAddText}
          </LinkText>
        </CreateFormAddText>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/CreateListForm/index.jsx